import { InfoIcon } from "lucide-react";

import { Button } from "@/components/ui/button";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";

interface InfoPopoverProps {
  message: string;
}

/*
 * Small info-bubble shown next to section labels and form fields. Click the
 * icon → popover with the explanatory text. Replaces the MUI Popover-based
 * original (src/components/info-popover/index.js) without changing the API
 * — every consumer still imports `<InfoPopover message={...} />`.
 */
export default function InfoPopover({ message }: InfoPopoverProps) {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          type="button"
          variant="ghost"
          size="icon-xs"
          aria-label="Info"
        >
          <InfoIcon className="size-4 text-muted-foreground" />
        </Button>
      </PopoverTrigger>
      <PopoverContent
        align="start"
        side="bottom"
        className="max-w-[300px] text-sm"
      >
        {message}
      </PopoverContent>
    </Popover>
  );
}
